import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import styles from './ConnectGoogleButton.scss';
import Button from 'components/controls/Button';

export default class ConnectGoogleButton extends PureComponent {
  static propTypes = {
    onGetConnectGoogleLink: PropTypes.func.isRequired,
    connectGoogleLink: PropTypes.string,
    connectGoogleLinkProcessing: PropTypes.bool,
  };

  static defaultProps = {
    connectGoogleLink: null,
    connectGoogleLinkProcessing: false,
  };

  componentDidMount() {
    const {onGetConnectGoogleLink} = this.props;

    onGetConnectGoogleLink();
  }

  render() {
    const {connectGoogleLink} = this.props;

    if (!connectGoogleLink) {
      return <div>{loc('already-connected-google')}</div>;
    }

    return (
      <a
        href={connectGoogleLink}
        className={styles.link}
      >
        <Button
          label={loc('connect-google')}
        />
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/controls/ConnectGoogleButton.jsx